import { Avatar, Box, Typography } from "@mui/material";

import { vcardDisplayName } from "../channel/mmsConstraints";

/**
 * Compact contact-card pill for the message preview — the name (derived from
 * the vCard filename) plus a monogram avatar. Representative only; the real
 * card is drawn by the recipient's handset.
 */
export function ContactCardPreview({ name }: { name: string }) {
  const displayName = vcardDisplayName(name);
  const monogram = displayName.trim().charAt(0).toUpperCase() || "?";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        alignSelf: "flex-start",
        padding: "6px 10px 6px 12px",
        backgroundColor: "#ffffff",
        border: "1px solid #e0e2e7",
        borderRadius: "8px",
      }}
    >
      <Typography variant="subtitle3" sx={{ color: "#1a1a1e" }}>
        {displayName}
      </Typography>
      <Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: "#c9ccd2" }}>
        {monogram}
      </Avatar>
    </Box>
  );
}
